import { render, staticRenderFns } from "./InlineCategorization.vue?vue&type=template&id=fecc4912&scoped=true&"
import script from "./InlineCategorization.vue?vue&type=script&lang=ts&"
export * from "./InlineCategorization.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fecc4912",
  null
  
)

export default component.exports